import { Button, Col, Modal, Row } from "antd";

import "./styles.less";

interface Props {
  cancelText?: string;
  okText?: string;
  titleText?: string;
  messageText?: string;
  onOk: () => void;
  onClose: () => void;
}
const Confirmation: React.FC<Props> = ({ cancelText, okText, titleText, messageText, onClose, onOk }) => {
  return (
    <Modal
      centered={true}
      visible={true}
      footer={null}
      closable={false}
      wrapClassName="modal-wrapper"
      width={500}
      maskTransitionName=""
    >
      <Col className="confirmation">
        <Row className="confirmation-title">{titleText}</Row>
        <Row className="confirmation-message">{messageText}</Row>

        <Row>
          <div className="btn-grp-wrapper">
            <Button className="primary-button" onClick={() => onClose()}>
              {cancelText ?? "Cancel"}
            </Button>
            <Button className="secondary-button" onClick={() => onOk()}>
              {okText ?? "Connfirm"}
            </Button>
          </div>
        </Row>
      </Col>
    </Modal>
  );
};

export default Confirmation;
